import styled from 'styled-components';

export const CreatePodSuccessWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
`;

export const Interior = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ImageWrapper = styled.div`
    display: flex;
    align-items: center;
    padding-top: 20px;
    max-height: 200px;
    @media (min-width: ${(props) => props.theme.breakpoints.tabletSmall}) {
        padding-top: 0;
        max-height: 180px;
    }
`;

export const StyledImage = styled.img`
    margin: 0 auto;
    width: 80px;

    @media (min-width: ${(props) => props.theme.breakpoints.tabletSmall}) {
        margin-bottom: 35px;
    }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 30px;

    & div:first-child {
        max-width: 250px;
        line-height: 100%;
    }

    div {
        margin: 0 auto;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.tabletSmall}) {
        gap: 10px;
        margin-bottom: 35px;

        & div:first-child {
            max-width: unset;
        }
    }
`;
